"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var view_models_1 = require("./../view-models");
var view_config_models_1 = require("./../view-config-models");
var validators_1 = require("./../validators");
var PostponedFlightsWrapperControlNames = (function () {
    function PostponedFlightsWrapperControlNames() {
    }
    return PostponedFlightsWrapperControlNames;
}());
PostponedFlightsWrapperControlNames.postponedFlights = 'postponedFlights';
exports.PostponedFlightsWrapperControlNames = PostponedFlightsWrapperControlNames;
var PostponedFlightsWrapperComponent = (function () {
    function PostponedFlightsWrapperComponent() {
    }
    Object.defineProperty(PostponedFlightsWrapperComponent.prototype, "postponedFormValue", {
        get: function () {
            if (this.postponedFlightsControl) {
                return this.postponedFlightsControl.value;
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    PostponedFlightsWrapperComponent.prototype.ngOnChanges = function (changes) {
        if ((changes['form'] || changes['postponed']) && this.form && this.postponed) {
            this.buildForm();
        }
        if (changes['config']) {
            this.populateMessaging();
        }
    };
    PostponedFlightsWrapperComponent.prototype.populateMessaging = function () {
        this.messages = {
            'flightsLaterRequired': this.config.flightsLaterRequired
        };
    };
    PostponedFlightsWrapperComponent.prototype.buildForm = function () {
        this.postponedFlightsControl = new forms_1.FormControl(this.postponed, validators_1.postponedFlightsValidator());
        this.form.addControl('postponedFlights', this.postponedFlightsControl);
    };
    PostponedFlightsWrapperComponent.prototype.showPostponedFlightsConfirm = function () {
        return this.postponedFormValue && this.postponedFormValue.noFlights ? this.postponedFormValue.flightsLater === true : false;
    };
    PostponedFlightsWrapperComponent.prototype.showNoPostponedFlightsConfirm = function () {
        return this.postponedFormValue && this.postponedFormValue.noFlights ? this.postponedFormValue.flightsLater === false : false;
    };
    return PostponedFlightsWrapperComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", forms_1.FormGroup)
], PostponedFlightsWrapperComponent.prototype, "form", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], PostponedFlightsWrapperComponent.prototype, "submitted", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", view_models_1.PostponedFlightsViewModel)
], PostponedFlightsWrapperComponent.prototype, "postponed", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", view_config_models_1.PostponedFlightsWrapperConfig)
], PostponedFlightsWrapperComponent.prototype, "config", void 0);
PostponedFlightsWrapperComponent = __decorate([
    core_1.Component({
        selector: 'postponed-flights-wrapper',
        template: "<ng-container *ngIf=\"postponedFlightsControl\">     <div class=\"row\">         <div class=\"col-xs-12\">             <postponed-flights [formControl]=\"postponedFlightsControl\" [config]=\"config\">                 <span text-config=\"flights-now-prompt\">                     <ng-content select=\"[text-config=flights-now-prompt]\"></ng-content>                 </span>                 <span text-config=\"flights-later-prompt\">                     <ng-content select=\"[text-config=flights-later-prompt]\"></ng-content>                 </span>                 <span text-config=\"flights-later-positive\">                     <ng-content select=\"[text-config=flights-later-positive]\"></ng-content>                 </span>                 <span text-config=\"flights-later-negative\">                     <ng-content select=\"[text-config=flights-later-negative]\"></ng-content>                 </span>             </postponed-flights>             <!-- This message needs to only display after submitted, shouldn't show up after being \"touched\" as is default -->             <validation-messages *ngIf=\"submitted\" [control]=\"postponedFlightsControl\" [messages]=\"messages\" [submitted]=\"submitted\"></validation-messages>         </div>     </div>     <ng-container *ngIf=\"showPostponedFlightsConfirm()\">         <p class=\"postponedFlightsConfirmMessage\">{{config.futureFlightsExpectedConfirmMessage}}</p>     </ng-container>     <ng-container *ngIf=\"showNoPostponedFlightsConfirm()\">         <p class=\"postponedFlightsConfirmMessage\">{{config.noFutureFlightsExpectedConfirmMessage}}</p>     </ng-container> </ng-container>"
    })
], PostponedFlightsWrapperComponent);
exports.PostponedFlightsWrapperComponent = PostponedFlightsWrapperComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/flight-builder/postponed-flights-wrapper.component.js